import axios from 'axios'
import { conactsApiServer } from '../config'

const sendContactsUrl = `${conactsApiServer}/api/sendContacts`
const sendSubmitUrl = `${conactsApiServer}/api/submit`

export const sendContacts = async (submitData: any) => {
  try {
    const result = await axios.post(sendContactsUrl, submitData)
    console.log(result.data.error)
    return !result.data.error || false
  } catch {
    return false
  }
}

export const sendSubmit = async (submitData: any) => {
  try {
    const result = await axios.post(sendSubmitUrl, submitData)
    return !result.data.error || false
  } catch {
    return false
  }
}
